
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as drive_45perso1ozvTZglApMeta } from "/builds/leviia/console/pages/discover/drive-perso.vue?macro=true";
import { default as drive_45proLzqWedMLjCMeta } from "/builds/leviia/console/pages/discover/drive-pro.vue?macro=true";
import { default as nextcloud_45massif28WXofMQf9Meta } from "/builds/leviia/console/pages/discover/nextcloud-massif.vue?macro=true";
import { default as object_45storage4cqZku30frMeta } from "/builds/leviia/console/pages/discover/object-storage.vue?macro=true";
import { default as indexgmfGMkhBB5Meta } from "/builds/leviia/console/pages/drive-pro/index.vue?macro=true";
import { default as helpXn1s7bElb2Meta } from "/builds/leviia/console/pages/help.vue?macro=true";
import { default as indexsE15W18sBBMeta } from "/builds/leviia/console/pages/index.vue?macro=true";
import { default as logoutrA6arH2zjSMeta } from "/builds/leviia/console/pages/logout.vue?macro=true";
import { default as alertscZAFP9KQdQMeta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/alerts.vue?macro=true";
import { default as create8dvIdMEVCbMeta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/buckets/create.vue?macro=true";
import { default as _91id_93LiWVcF5dlBMeta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/buckets/edit/[id].vue?macro=true";
import { default as indexsEvAraiPWbMeta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/buckets/index.vue?macro=true";
import { default as createUMLmE9fXpqMeta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/identifiers/create.vue?macro=true";
import { default as _91id_93GOwO7B6Qk6Meta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/identifiers/edit/[id].vue?macro=true";
import { default as indexRVevbXeQO7Meta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/identifiers/index.vue?macro=true";
import { default as statistiquesTutbsubaeBMeta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/statistiques.vue?macro=true";
import { default as tokenHt0fy3Es96Meta } from "/builds/leviia/console/pages/object-storage/[[clientId]]/token.vue?macro=true";
import { default as clientsZcOPfkhqy0Meta } from "/builds/leviia/console/pages/partner/clients.vue?macro=true";
import { default as silent_45check_45ssozs55rXZYH3Meta } from "/builds/leviia/console/pages/silent-check-sso.vue?macro=true";
import { default as testetXESqyTkfMeta } from "/builds/leviia/console/pages/test.vue?macro=true";
import { default as detailsx8zWDYbKA0Meta } from "/builds/leviia/console/pages/user/billing/details.vue?macro=true";
import { default as invoicesw2xdQEhVtxMeta } from "/builds/leviia/console/pages/user/billing/invoices.vue?macro=true";
import { default as payment_45methodsRYs1SRdGfKMeta } from "/builds/leviia/console/pages/user/billing/payment-methods.vue?macro=true";
import { default as infosxZr5kbItZIMeta } from "/builds/leviia/console/pages/user/infos.vue?macro=true";
import { default as security4NOa3VfHSBMeta } from "/builds/leviia/console/pages/user/security.vue?macro=true";
import { default as drive_45pro0hXYebJuFpMeta } from "/builds/leviia/console/pages/user/subscriptions/drive-pro.vue?macro=true";
import { default as driveqLLZcUcIb7Meta } from "/builds/leviia/console/pages/user/subscriptions/drive.vue?macro=true";
import { default as indexR9x1vosQvMMeta } from "/builds/leviia/console/pages/user/subscriptions/index.vue?macro=true";
import { default as no_45subxk19PBO5crMeta } from "/builds/leviia/console/pages/user/subscriptions/no-sub.vue?macro=true";
import { default as object_45storagebTSvacDlVXMeta } from "/builds/leviia/console/pages/user/subscriptions/object-storage.vue?macro=true";
import { default as partnerNdIRaDpwHWMeta } from "/builds/leviia/console/pages/user/subscriptions/partner.vue?macro=true";
import { default as indexxJZxdMKtq0Meta } from "/builds/leviia/console/pages/user/team/index.vue?macro=true";
import { default as editVdsKpu1SfrMeta } from "/builds/leviia/console/pages/user/team/member/[id]/edit.vue?macro=true";
import { default as createkOyG4iEE7vMeta } from "/builds/leviia/console/pages/user/team/member/create.vue?macro=true";
export default [
  {
    name: drive_45perso1ozvTZglApMeta?.name ?? "discover-drive-perso",
    path: "/discover/drive-perso",
    meta: drive_45perso1ozvTZglApMeta || {},
    component: () => import("/builds/leviia/console/pages/discover/drive-perso.vue")
  },
  {
    name: drive_45proLzqWedMLjCMeta?.name ?? "discover-drive-pro",
    path: "/discover/drive-pro",
    meta: drive_45proLzqWedMLjCMeta || {},
    component: () => import("/builds/leviia/console/pages/discover/drive-pro.vue")
  },
  {
    name: nextcloud_45massif28WXofMQf9Meta?.name ?? "discover-nextcloud-massif",
    path: "/discover/nextcloud-massif",
    meta: nextcloud_45massif28WXofMQf9Meta || {},
    component: () => import("/builds/leviia/console/pages/discover/nextcloud-massif.vue")
  },
  {
    name: object_45storage4cqZku30frMeta?.name ?? "discover-object-storage",
    path: "/discover/object-storage",
    meta: object_45storage4cqZku30frMeta || {},
    component: () => import("/builds/leviia/console/pages/discover/object-storage.vue")
  },
  {
    name: indexgmfGMkhBB5Meta?.name ?? "drive-pro",
    path: "/drive-pro",
    meta: indexgmfGMkhBB5Meta || {},
    component: () => import("/builds/leviia/console/pages/drive-pro/index.vue")
  },
  {
    name: helpXn1s7bElb2Meta?.name ?? "help",
    path: "/help",
    meta: helpXn1s7bElb2Meta || {},
    component: () => import("/builds/leviia/console/pages/help.vue")
  },
  {
    name: indexsE15W18sBBMeta?.name ?? "index",
    path: "/",
    meta: indexsE15W18sBBMeta || {},
    component: () => import("/builds/leviia/console/pages/index.vue")
  },
  {
    name: logoutrA6arH2zjSMeta?.name ?? "logout",
    path: "/logout",
    meta: logoutrA6arH2zjSMeta || {},
    component: () => import("/builds/leviia/console/pages/logout.vue")
  },
  {
    name: alertscZAFP9KQdQMeta?.name ?? "object-storage-clientId-alerts",
    path: "/object-storage/:clientId?/alerts",
    meta: alertscZAFP9KQdQMeta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/alerts.vue")
  },
  {
    name: create8dvIdMEVCbMeta?.name ?? "object-storage-clientId-buckets-create",
    path: "/object-storage/:clientId?/buckets/create",
    meta: create8dvIdMEVCbMeta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/buckets/create.vue")
  },
  {
    name: _91id_93LiWVcF5dlBMeta?.name ?? "object-storage-clientId-buckets-edit-id",
    path: "/object-storage/:clientId?/buckets/edit/:id()",
    meta: _91id_93LiWVcF5dlBMeta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/buckets/edit/[id].vue")
  },
  {
    name: indexsEvAraiPWbMeta?.name ?? "object-storage-clientId-buckets",
    path: "/object-storage/:clientId?/buckets",
    meta: indexsEvAraiPWbMeta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/buckets/index.vue")
  },
  {
    name: createUMLmE9fXpqMeta?.name ?? "object-storage-clientId-identifiers-create",
    path: "/object-storage/:clientId?/identifiers/create",
    meta: createUMLmE9fXpqMeta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/identifiers/create.vue")
  },
  {
    name: _91id_93GOwO7B6Qk6Meta?.name ?? "object-storage-clientId-identifiers-edit-id",
    path: "/object-storage/:clientId?/identifiers/edit/:id()",
    meta: _91id_93GOwO7B6Qk6Meta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/identifiers/edit/[id].vue")
  },
  {
    name: indexRVevbXeQO7Meta?.name ?? "object-storage-clientId-identifiers",
    path: "/object-storage/:clientId?/identifiers",
    meta: indexRVevbXeQO7Meta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/identifiers/index.vue")
  },
  {
    name: statistiquesTutbsubaeBMeta?.name ?? "object-storage-clientId-statistiques",
    path: "/object-storage/:clientId?/statistiques",
    meta: statistiquesTutbsubaeBMeta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/statistiques.vue")
  },
  {
    name: tokenHt0fy3Es96Meta?.name ?? "object-storage-clientId-token",
    path: "/object-storage/:clientId?/token",
    meta: tokenHt0fy3Es96Meta || {},
    component: () => import("/builds/leviia/console/pages/object-storage/[[clientId]]/token.vue")
  },
  {
    name: clientsZcOPfkhqy0Meta?.name ?? "partner-clients",
    path: "/partner/clients",
    meta: clientsZcOPfkhqy0Meta || {},
    component: () => import("/builds/leviia/console/pages/partner/clients.vue")
  },
  {
    name: "silent-check-sso",
    path: "/silent-check-sso",
    component: () => import("/builds/leviia/console/pages/silent-check-sso.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/builds/leviia/console/pages/test.vue")
  },
  {
    name: detailsx8zWDYbKA0Meta?.name ?? "user-billing-details",
    path: "/user/billing/details",
    meta: detailsx8zWDYbKA0Meta || {},
    component: () => import("/builds/leviia/console/pages/user/billing/details.vue")
  },
  {
    name: invoicesw2xdQEhVtxMeta?.name ?? "user-billing-invoices",
    path: "/user/billing/invoices",
    meta: invoicesw2xdQEhVtxMeta || {},
    component: () => import("/builds/leviia/console/pages/user/billing/invoices.vue")
  },
  {
    name: payment_45methodsRYs1SRdGfKMeta?.name ?? "user-billing-payment-methods",
    path: "/user/billing/payment-methods",
    meta: payment_45methodsRYs1SRdGfKMeta || {},
    component: () => import("/builds/leviia/console/pages/user/billing/payment-methods.vue")
  },
  {
    name: infosxZr5kbItZIMeta?.name ?? "user-infos",
    path: "/user/infos",
    meta: infosxZr5kbItZIMeta || {},
    component: () => import("/builds/leviia/console/pages/user/infos.vue")
  },
  {
    name: security4NOa3VfHSBMeta?.name ?? "user-security",
    path: "/user/security",
    meta: security4NOa3VfHSBMeta || {},
    component: () => import("/builds/leviia/console/pages/user/security.vue")
  },
  {
    name: drive_45pro0hXYebJuFpMeta?.name ?? "user-subscriptions-drive-pro",
    path: "/user/subscriptions/drive-pro",
    meta: drive_45pro0hXYebJuFpMeta || {},
    component: () => import("/builds/leviia/console/pages/user/subscriptions/drive-pro.vue")
  },
  {
    name: driveqLLZcUcIb7Meta?.name ?? "user-subscriptions-drive",
    path: "/user/subscriptions/drive",
    meta: driveqLLZcUcIb7Meta || {},
    component: () => import("/builds/leviia/console/pages/user/subscriptions/drive.vue")
  },
  {
    name: indexR9x1vosQvMMeta?.name ?? "user-subscriptions",
    path: "/user/subscriptions",
    meta: indexR9x1vosQvMMeta || {},
    component: () => import("/builds/leviia/console/pages/user/subscriptions/index.vue")
  },
  {
    name: no_45subxk19PBO5crMeta?.name ?? "user-subscriptions-no-sub",
    path: "/user/subscriptions/no-sub",
    meta: no_45subxk19PBO5crMeta || {},
    component: () => import("/builds/leviia/console/pages/user/subscriptions/no-sub.vue")
  },
  {
    name: object_45storagebTSvacDlVXMeta?.name ?? "user-subscriptions-object-storage",
    path: "/user/subscriptions/object-storage",
    meta: object_45storagebTSvacDlVXMeta || {},
    component: () => import("/builds/leviia/console/pages/user/subscriptions/object-storage.vue")
  },
  {
    name: partnerNdIRaDpwHWMeta?.name ?? "user-subscriptions-partner",
    path: "/user/subscriptions/partner",
    meta: partnerNdIRaDpwHWMeta || {},
    component: () => import("/builds/leviia/console/pages/user/subscriptions/partner.vue")
  },
  {
    name: indexxJZxdMKtq0Meta?.name ?? "user-team",
    path: "/user/team",
    meta: indexxJZxdMKtq0Meta || {},
    component: () => import("/builds/leviia/console/pages/user/team/index.vue")
  },
  {
    name: editVdsKpu1SfrMeta?.name ?? "user-team-member-id-edit",
    path: "/user/team/member/:id()/edit",
    meta: editVdsKpu1SfrMeta || {},
    component: () => import("/builds/leviia/console/pages/user/team/member/[id]/edit.vue")
  },
  {
    name: createkOyG4iEE7vMeta?.name ?? "user-team-member-create",
    path: "/user/team/member/create",
    meta: createkOyG4iEE7vMeta || {},
    component: () => import("/builds/leviia/console/pages/user/team/member/create.vue")
  }
]